const F = window.__GENERATED_CONSTANTS__.Features

export const Feature = {
    CPTBUD: F.CPTBUD, //Customer, Project or Task Budgets
    TTF: F.TTF, // Time Track in Future
    LVT: F.LVT, // Leave Time Tracking
    TST: F.TST, // Timesheet Tracking (Table View)
    FTT: F.FTT, // From-To Timetrack (Calendar View)
    PTO: F.PTO, // LVT -> PTO Balance
    SDB: F.SDB, // LVT -> Sick Days Balance
    OVR: F.OVR, // Overtime
    TTA: F.TTA, // Time Track Approval
    UGR: F.UGR, // User Groups
    TZG: F.TZG, // Time Zone Groups
    EST: F.EST, // Estimate
    TWS: F.TWS, // Task Workflow Statuses
    WAS: F.WAS, // Work Assignments
    URA: F.URA, // User Rates
    BTY: F.BTY, // Billing Types
    BRA: F.BRA, // BTY -> Billing Rates

    LTT: F.LTT, // Lock Time Track
    TTC: F.TTC, // Time Track in Details Report
    CLT: F.CLT, // Custom Leave Types
    QBI: F.QBI, // QuickBooks Integration
    CFI: F.CFI, // Custom fields
    WSD: F.WSD, // Work Scheduling / Work Statuses

    // actiPLANS
    APUGR: F.APUGR,
    APTZG: F.APTZG,
    APPTO: F.APPTO,
    APSDB: F.APSDB,
    APWSD: F.APWSD,
}



// WEBPACK FOOTER //
// ./web/js/features/constants.js